import { AppBar as AppBarMui, styled, Toolbar as ToolbarMui } from '@mui/material';

export const AppBar = styled(AppBarMui)(() => ({
  padding: '24px 24px 12px',
  position: 'static',
  backgroundColor: 'unset',
  color: 'unset',
  boxShadow: 'unset',
  zIndex: 1000,
}));

export const ToolBar = styled(ToolbarMui)(() => ({
  height: 48,
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  '@media all': {
    padding: 'unset',
    minHeight: 'unset',
  },
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  alignContent: 'center',
}));

export const ButtonWrapper = styled('div')(() => ({
  marginRight: 12,
}));

export const Menu = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  justifyItems: 'end',
  justifySelf: 'end',
  gap: 12,
}));
